// Serviço para buscar configurações públicas do sistema
// Estas configurações vêm do banco de dados via backend

import { api } from './api'

export interface PublicSettings {
  trial_days: number
  price_per_seat: number
}

// Cache em memória para evitar requisições repetidas
let cachedSettings: PublicSettings | null = null
let cacheTimestamp: number = 0
const CACHE_TTL = 5 * 60 * 1000 // 5 minutos

export const settingsService = {
  /**
   * Obtém as configurações públicas do sistema
   * Usa cache para evitar requisições desnecessárias
   */
  async getPublicSettings(): Promise<PublicSettings> {
    const now = Date.now()
    
    // Retorna do cache se ainda válido
    if (cachedSettings && (now - cacheTimestamp) < CACHE_TTL) {
      return cachedSettings as PublicSettings
    }

    try {
      const response = await api.get('/api/v1/public/settings')
      
      cachedSettings = response.data.data as PublicSettings
      cacheTimestamp = now
      
      return cachedSettings
    } catch (error) {
      // Se falhar, retorna valores padrão
      console.error('Erro ao carregar configurações públicas:', error)
      return {
        trial_days: 7,
        price_per_seat: 49.90
      }
    }
  },

  /**
   * Obtém a quantidade de dias de trial
   */
  async getTrialDays(): Promise<number> {
    const settings = await this.getPublicSettings()
    return settings.trial_days
  },

  /**
   * Obtém o preço por assento
   */
  async getPricePerSeat(): Promise<number> {
    const settings = await this.getPublicSettings()
    return settings.price_per_seat
  },

  /**
   * Limpa o cache (útil após mudanças de configuração)
   */
  clearCache(): void {
    cachedSettings = null
    cacheTimestamp = 0
  }
}
